import { LANGUAGE_DISPLAY_NAMES } from '@shared/core/localized-defaults'
import { TriangleAlert } from 'lucide-react'
import { useIntl } from 'react-intl'
import { FormattedText, Typography } from 'src/modules/core/components'
import { MessageLanguageSelect } from 'src/modules/user/components/client-message-language-card/message-language-select'
import { useMessageLanguageSourceText } from 'src/modules/user/hooks/use-message-language-source-text'
import type { TemplateLanguageFieldProps } from './template-language-field.interface'
import classes from './template-language-field.module.scss'

export function TemplateLanguageField({ value, savedValue, accountLanguage, onChange }: TemplateLanguageFieldProps) {
  const { formatMessage } = useIntl()
  const accountSourceText = useMessageLanguageSourceText(accountLanguage.source, accountLanguage.countryCode) ?? ''
  const effectiveLanguage = value ?? accountLanguage.language

  return (
    <div className={classes.root}>
      <MessageLanguageSelect
        className={classes.field}
        fullWidth
        look="form"
        value={value}
        automaticLanguage={accountLanguage.language}
        automaticLabel={formatMessage(
          { id: 'settings.messageLanguage.template.useAccount' },
          { language: LANGUAGE_DISPLAY_NAMES[accountLanguage.language].english },
        )}
        automaticSourceText={formatMessage(
          { id: 'settings.messageLanguage.template.followsAccount' },
          { source: accountSourceText },
        )}
        groupHeading={formatMessage({ id: 'settings.messageLanguage.template.groupHeading' })}
        chosenTag={formatMessage({ id: 'settings.messageLanguage.template.pinnedTag' })}
        onChange={onChange}
      />
      {savedValue !== undefined && value !== savedValue && (
        <div className={classes.warning} role="note" data-testid="template-language-warning">
          <TriangleAlert className={classes.warningIcon} size={18} aria-hidden="true" />
          <Typography variant="body" className={classes.warningText}>
            <FormattedText
              id="settings.messageLanguage.template.savedTextWarning"
              values={{ language: LANGUAGE_DISPLAY_NAMES[effectiveLanguage].english }}
            />
          </Typography>
        </div>
      )}
    </div>
  )
}
